export class CoordinatesOutDTO {
  latitude!: number;
  longitude!: number;
}
